import fernet from "fernet";
import { isNullOrUndefined } from "./validations";
import { ShowAlertLoginErrorDecripted } from "./alerts";

/**
 * Encodes the given data using a secret key stored in local storage.
 * If the secret key is null or undefined, an alert is shown and null is returned.
 * @param {Object} data - The data to be encoded.
 * @returns {string|null} The encoded data as a string, or null if the secret key is not available.
 */
export const encodeData = (data) => {
  const secretKey = window.localStorage.getItem("KEY_35");
  if (isNullOrUndefined(secretKey) === true) {
    ShowAlertLoginErrorDecripted();
    return null;
  }

  const secret = new fernet.Secret(secretKey);
  const token = new fernet.Token({
    secret,
    ttl: 0,
  });

  return token.encode(JSON.stringify(data));
};

/**
 * Decodes a given data string using a secret key stored in local storage.
 * If the secret key is missing or invalid, an alert is shown and null is returned.
 * @param {string} data - The encoded data string to be decoded.
 * @returns {Object|null} The decoded data as a JSON object, or null if decoding fails.
 */
export const decodeData = (data) => {
  const secretKey = window.localStorage.getItem("KEY_35");
  if (isNullOrUndefined(secretKey) === true) {
    return null;
  }

  try {
    const secret = new fernet.Secret(secretKey);
    const token = new fernet.Token({
      secret,
      token: data,
      ttl: 0,
    });

    const decoded = token.decode();
    return JSON.parse(decoded);
  } catch (error) {
    return null;
  }
};
